import React, { useRef } from "react"
import { useFakeLoading } from '../hooks/'
import { ThemeProvider } from 'styled-components'
import GlobalStyle, { theme } from '../GlobalStyle'

import SEO from "../components/seo"
import Layout from "../components/template/layout"
import LoadingTransition from '../components/commons/LoadingTransition'
import Floating from '../components/Home/Floating'
import BurgerMenu from '../components/shared/BurgerMenu'
import Background from '../components/Home/Background'
import Top from "../components/Home/Header"
import Content from '../components/shared/Content'
import { Message, Attention, Event, Access, Info } from '../components/Home/sections'

const IndexPage = () => {

  const isLoading = useFakeLoading()

  const sections = [
    { title: 'Top', ref: useRef() },
    { title: 'Message', ref: useRef() },
    { title: 'Attention', ref: useRef() },
    { title: 'Talk Show', ref: useRef() },
    { title: 'Access', ref: useRef() },
    { title: 'Info', ref: useRef() },
  ]

  return (
    <>
      <SEO title="情報デザイン学科卒業制作展2021" />
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <Background />
        <LoadingTransition isLoading={isLoading}>
          <Floating />
          <Layout>
            <BurgerMenu targets={sections} />
            <Content target={sections[0]}><Top /></Content>
            <main>
              <Content target={sections[1]}><Message /></Content>
              <Content target={sections[2]}><Attention /></Content>
              <Content target={sections[3]}><Event /></Content>
              <Content target={sections[4]}><Access /></Content>
              <Content target={sections[5]}><Info /></Content>
            </main>
          </Layout>
        </LoadingTransition>
      </ThemeProvider>
    </>
  )
}

export default IndexPage
